import {
    useCallback
} from "react";
import {
    type DocsLanguage,
    useDocsI18n
} from "../i18n";
import en from "../locales/createPreview/en.json";
import tr from "../locales/createPreview/tr.json";

const PREVIEW_DICTIONARIES: Record<DocsLanguage, Record<string, string>> = {
    en,
    tr
};

export const usePreviewText = () => {
    const {
        language
    } = useDocsI18n();

    return useCallback((key: string) => PREVIEW_DICTIONARIES[language][key] ?? PREVIEW_DICTIONARIES.tr[key] ?? key, [
        language
    ]);
};
